import React from 'react';

import PromotionMaster from './PromotionMaster';
import './PromotionCriteria.css';

const PromotionCriteria = () => {
  return (
    <div>
      <PromotionMaster />
    </div>
  );
};

export default PromotionCriteria;
